import { concat, isEmpty, get, cloneDeep } from 'lodash';
import SubmitType from './Submit.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  submitListData: [],
  submitSelectedIds: [],
  submitFilterValues: {
    selected_Season: [],
    selected_Year: [],
    selected_Brand: [],
    selected_Supplier: [],
    selected_Type: '',
    selected_Category1: [],
    selected_Category2: [],
    selected_Category3: [],
    selected_Category4: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    loading: false,
  },
  submitListTotalCount: 0,
  currentRequestId: null,
};

const submitTodoListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SubmitType.SET_SUBMIT_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      const updatedArry = cloneDeep(setArrayByCase(state.submitListData, action.payload));
      return {
        ...state,
        submitListData: updatedArry,
        submitListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case SubmitType.SET_SUBMIT_SELECTED_IDS_ARRAY:
      return {
        ...state,
        submitSelectedIds: action.payload,
      };
    case SubmitType.SET_SUBMIT_SORT_DATA:
      return {
        ...state,
        submitFilterValues: {
          ...state.submitFilterValues,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  return payload.data;
};

export default submitTodoListReducer;
